// @flow
import React from 'react';
import classNames from 'classnames/bind';

import PlainLink from 'app/common/ui-next/plain-link';
import IconRate from 'app/common/icons/IconRate';

import MoreLink from '../MoreLink';
import styles from './CardMarks.scss';


type Props = {
  className: string,
  studentId: string,
  dayMarks: Array<{
    id: string,
    val: string,
    text: string,
  }>
}

const CardGrades = ({
  className,
  studentId,
  dayMarks,
}: Props) => {
  const link = `/apps/${studentId}/dnevnik/home`;

  return (
    <div className={classNames(styles.root, className)}>
      {dayMarks.map(item =>
        <div className={styles.item} key={item.id}>
          {item.text}
          {' — '}
          {item.val}
          {/(2|1|h|н|o|о)/i.test(item.val)
            && <div className={styles.warn} />}
        </div>)}

      <PlainLink to={link} className={styles.icon}>
        <IconRate />
      </PlainLink>

      <MoreLink to={link} />
    </div>
  );
};

export default CardGrades;
